import React, {useState,useEffect, useRef} from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Popup from '../components/Popup';
import { sendAnalyticsData } from '../utilities/analytics';
import Cookies from 'universal-cookie';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PageLanding = (e) => {

  const [isOpen, setIsOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [isChecked, setIsChecked] = useState(false);

  const [isVideoHide, setIsVideoHide] = useState(false);
  const [isStepHide, setIsStepHide] = useState(true);
  const [isLandingHide, setIsLandingHide] = useState(true);
  // const [isChecked2, setIsChecked2] = useState(false);
  
  const settings = {
    dots: false,
    infinite: true,
    accessibility: false,
    arrows: false,
    speed: 1800,
    autoplaySpeed: 3000,
    fade: true,
    slidesToShow: 1,
    autoplay: true
  };
  useEffect(() => {
    const cookies = new Cookies();
    let event_name = new URL(window.location.href).searchParams.get('event_name');
    if (event_name) {
      cookies.set('event_name', event_name, {path: '/', expires: new Date(Date.now() + 24*3600*1000)});
    }
    sendAnalyticsData('View Page','Landing Page')
  }, [])

  const handleVideoClick = () => {
    setIsVideoHide(true);
    setIsStepHide(false);
  };

  const handleStepClick = () => {
    setIsVideoHide(true);
    setIsStepHide(true);
    setIsLandingHide(false);
  };
  
  const navigate = useNavigate();
  const { type } = useParams();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    
    if(!isChecked){
      setButtonDisabled(false)
    }else{
      setButtonDisabled(true);
    }
  };

  const togglePopup = (type) => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    sendAnalyticsData('View Page','Hint Page')
  }, [])
  
  return (
    <div className='landing-container'>
      {/* <Slider className='bg-landing-slider' {...settings}>
        <div className='bg-landing bg-landing0'></div>
        <div className='bg-landing bg-landing1'></div>
        <div className='bg-landing bg-landing2'></div>
        <div className='bg-landing bg-landing3'></div>
        <div className='bg-landing bg-landing4'></div>
      </Slider> */}

      <div onClick={handleVideoClick} className={isVideoHide? 'intro-video hide' : 'intro-video'}>
        <video src='/videos/Color_Intelligence.mp4' muted autoPlay playsInline loop={true}/>
          <p>[ tap anywhere to continue ]</p>
      </div>

      <div onClick={handleStepClick} className={isStepHide? 'intro-step hide' : 'intro-step'}>
        <div className='intro-step-inner'>
          <h2>HOW TO USE</h2>
          <div className='step-list'>
            <h3>1. Prepare Your Face</h3>
            <span>Ensure your face is clean and free of makeup for the most accurate result</span>
          </div>
          <div className='step-list'>
            <h3>2. Position Yourself</h3>
            <span>Stand directly in front of the LED screen with proper lighting</span>
          </div>
          <div className='step-list'>
            <h3>3. Analyze &amp; Discover</h3>
            <span>Let the technology analyze your unique features and reveal your ideal personal color palette</span>
          </div>
        </div>
      </div>

      <div className={isLandingHide? 'intro-landing hide' : 'intro-landing'}>
        <div className='landing-title'>
          <img className='logo-landing' src='/images/logo.png' alt=''/>
          <h1>
            Find Your Own<br/>
            <span>Personal Color Season</span>
          </h1>
          <h3>Get to know your personal color to<br/>find the colors that suits you best!</h3>
        </div>

        <div className="landing-button d-flex flex-column w-100">
          <Link className='btn btn-primary d-table w-100 mx-auto mb-3' onClick={() => {togglePopup('basic');  sendAnalyticsData('Click','Start at Hint Page')}}>
            Find My Personal Color
          </Link>
          {/* <Link className='btn btn-primary d-table w-100 mx-auto mb-3' href={"https://wardah-colourstory.com/"} target={"_blank"} onClick={() => { sendAnalyticsData('Click','Go To Virtual Try On')}}>
            Virtual Try On
          </Link>
          <Link className='btn btn-primary d-table w-100 mx-auto' href={""} target={"_blank"} onClick={() => {sendAnalyticsData('Click','Go to Colour Story')}}>
            Colour Story
          </Link> */}
        </div>
      </div>
      
      <Popup isOpen={isOpen} onClose={togglePopup} type={type}>
        <div className='term-condition py-4 px-4'>
          <h2 className='mb-4'>
            OUR PRIVACY<br/> POLICY
          </h2>
          <div className='term-condition-check pb-2 mb-4'>
            <label className='checkbox'>
              <input
                name='tnc'
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span>
                I have read, understand and accept the <Link to='https://www.wardahbeauty.com/en/privacy-policy' target='_blank' onClick={() => {sendAnalyticsData('Click','Privacy Policy Link')}}>privacy policy</Link>
              </span>
            </label>
          </div>
          <Link to={`/expert/hint`}  onClick={() => {sendAnalyticsData('Click','Go to Real Expert Page')}} className={`btn btn-primary w-100 ${buttonDisabled ? 'disabled' : ''}`}>
            AGREE
          </Link>
        </div>
      </Popup>
    </div>
  );
};

export default PageLanding;
